import { RouteHttpVerb } from "@devowl-wp/utils";
const locationRestJobResultPost = {
    path: "/job/:id/result",
    method: RouteHttpVerb.POST
};
export { locationRestJobResultPost };
